<template>
  <div class="productListBox">
    <van-overlay :show="IsloadingBox" />
    <div class="loadingBox" v-if="IsloadingBox">
      <Loading
        accountFont="数据请求中，请稍后..."
        size="120"
        color="#eee"
        type="spinner"
        >数据请求中，请稍后...</Loading
      >
    </div>
    <address-header
      ref="AddressRef"
      @getLatLng="getLatLng"
      :getProductList="getProductList"
    ></address-header>
    <div class="tabBox">
      <div
        v-for="(e, index) in tabList"
        :key="index"
        :class="`${e.id === tabId ? 'active' : ''} tabItem`"
        @click="switchClick(e.id)"
      >
        {{ e.name }}
      </div>
    </div>
    <div class="productItemBox">
      <default-product-item v-if="defaultFlag"></default-product-item>
      <product-item
        ref="productItemRef"
        :key="index"
        v-for="(item, index) in productList"
        :productItemData="item"
      >
      </product-item>

      <div v-if="productList && productList.length <= 0 && !IsloadingBox">
        <div class="noProduct">
          <img src="@/assets/images/nochanping.png" alt="" />
          <p>抱歉，当前所在区域/渠道暂无可申请产品!</p>
        </div>
        <div class="gray"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/Loading.vue';
import ProductItem from './ProductItem.vue';
import AddressHeader from './AddressHeader.vue';
import DefaultProductItem from './DefaultProductItem.vue';

export default {
  name: 'ProductList',
  data() {
    return {
      tabList: [
        {
          name: '通过率高',
          id: '0',
        },
        {
          name: '利率优先',
          id: '1',
        },
        {
          name: '额度优先',
          id: '2',
        },
      ],
      productList: null,
      IsloadingBox: false,
      defaultFlag: true,
      tabId: '0',
      address: '',
      districtId: '',
    };
  },
  mounted() {
    this.IsloadingBox = false;
  },
  methods: {
    switchClick(id) {
      this.tabId = id;
      this.getProductList(this.districtId);
    },
    getLatLng({ lat, lng }) {
      console.log(lat, lng);
    },
    async getProductList(code) {
      if (code) {
        this.districtId = code;
      }
      this.$api.LoanSupermarket.productList({
        districtId: code || '999999',
        seq: this.tabId,
      }).then((res) => {
        this.defaultFlag = false;
        if (res.success) {
          this.productList = res.data.list || [];
        }
      });
    },
  },
  components: {
    ProductItem,
    Loading,
    AddressHeader,
    DefaultProductItem,
  },
};
</script>
<style scoped>
.productListBox {
  background: #fff;
}

.tabBox {
  height: 30px;
  padding: 10px 15px 0;
}
.tabBox .tabItem {
  float: left;
  height: 22px;
  background: #fff;
  font-family: PingFangSC-Regular;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
  font-size: 13px;
  line-height: 22px;
  margin-right: 10px;
  padding: 0 10px;
  border-radius: 4px;
  color: #a2a2a2;
  font-weight: bold;
}
.tabBox .active {
  color: #f55646;
}
.loadingBox {
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* height: 100%; */
}
.noProduct {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.noProduct img {
  width: 45px;
  height: 30px;
  color: #eee;
}
.noProduct p {
  margin-top: 10px;
  font-size: 12px;
  color: #b7bfd2;
}
.gray {
  width: 100%;
  height: 40px;
  background: #f8f8f9;
}
</style>
